import type { SVGProps } from "react";
import { memo } from "react";
const GenomicsCLI = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#C8511B" />
        <stop offset="100%" stopColor="#F90" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M54.142 21.071h7.715v-2h-7.715zM53 15.929h10v-2H53zM54 43h8v-2h-8zm-1 5h10v-2H53zm-19.293-1.293a1 1 0 0 0 0-1.414l-12-12-1.414 1.414L31.586 46 20.293 57.293l1.414 1.414zM34 58h20v-2H34zm34 8V56h-2v10H14V14h28v-2H14c-1.103 0-2 .897-2 2v52c0 1.103.897 2 2 2h52c1.103 0 2-.897 2-2M50 45.711c0-3.015 1.132-5.888 3.188-8.091l11.086-11.875A13.81 13.81 0 0 0 68 16.289V12h-2v4.289c0 3.015-1.132 5.888-3.188 8.091L51.726 36.255A13.81 13.81 0 0 0 48 45.711V50h2zm10.737-13.246-1.369 1.466 3.444 3.689A11.82 11.82 0 0 1 66 45.711V50h2v-4.289c0-3.523-1.323-6.881-3.726-9.456zm-9.011-6.72A13.81 13.81 0 0 1 48 16.289V12h2v4.289c0 3.015 1.132 5.888 3.188 8.091l3.444 3.689-1.369 1.466z"
      />
    </g>
  </svg>
);
const Memo = memo(GenomicsCLI);
export default Memo;
